import {texture} from "p3";
import common from "../../common";
import GameScene from "../../scenes/GameScene";
import {iswebfont, locale, resizeLabelToFitText} from "../../utils";

export default class LocationTitle extends PIXI.Container {
    /**
     * @param {string} title
     */
    constructor(title) {
        super();

        this._title = title;
        this._banner = null;

        this.init();
    }

    init() {

        this.position.set(common.STAGE_WIDTH/2, -500);

        this._banner = new PIXI.Sprite(texture('title_map'));
        this._banner.anchor.set(0.5, 0);
        this.addChild(this._banner);

        if (!iswebfont()) {
            this._label = new PIXI.BitmapText(this._title.toUpperCase(), {
                fontName: "Alghera Pro",
                fontSize: 40,
                align: "center",
                tint: 0x000000
            });
        } else {
            this._label = new PIXI.Text(this._title.toUpperCase(), {
                fontFamily: "FredFredBurger",
                fontSize: 40,
                align: "center",
                fill: 0x0
            });
        }
        this._label.anchor.set(0.5);
        this._label.y = !iswebfont() ? 55 : 52;
        resizeLabelToFitText(this._label, 320);
        this.addChild(this._label);

        this.animateIn();
        this.animateOut();
    }

    animateIn() {
        GameScene.active.addTween(gsap.to(this, 1, {delay:0.5, y:100, ease:Expo.easeOut}));
    }

    animateOut() {
        GameScene.active.addTween(gsap.to(this, 1, {delay:3, y:-500, ease:Expo.easeIn, onComplete:() => {
            this.parent.removeChild(this);
        }}));
    }
}


